import { ActivityTypeEnum } from '@sport-activities/sdk';

import { RoutingInterface } from '~/core/services/navigation/interfaces/routing.interface';

export const organizerActivityCreationRoutingConfig: RoutingInterface[] = [
  {
    routeName: 'organizer.planning.planning',
  },
  {
    routeName: 'organizer.activity-creation.welcome',
  },
  {
    routeName: 'organizer.activity-creation.advice',
  },
  {
    routeName: 'organizer.activity-creation.steps',
  },
  {
    routeName: 'organizer.activity-creation.steps-1',
  },
  {
    routeName: 'organizer.activity-creation.type',
  },
  {
    routeName: 'organizer.activity-creation.sport',
    excludeActivityTypes: [
      'BIRTHDAY' as ActivityTypeEnum,
      'PRODUCT_TEST' as ActivityTypeEnum,
    ],
  },
  {
    routeName: 'organizer.activity-creation.duration',
  },
  {
    routeName: 'organizer.activity-creation.audience',
    excludeActivityTypes: [
      'BIRTHDAY' as ActivityTypeEnum,
      'PRODUCT_TEST' as ActivityTypeEnum,
    ],
  },
  {
    routeName: 'organizer.activity-creation.address',
    activityTypes: [
      'GROUP_LESSON' as ActivityTypeEnum,
      'GROUP_OUTING' as ActivityTypeEnum,
      'WORKSHOP' as ActivityTypeEnum,
      'MULTI_DAY_COURSE' as ActivityTypeEnum,
      'EVENT' as ActivityTypeEnum,
      'PLAYGROUND_RENT' as ActivityTypeEnum,
      'BIRTHDAY' as ActivityTypeEnum,
      'PRODUCT_TEST' as ActivityTypeEnum,
    ],
  },
  {
    routeName: 'organizer.activity-creation.equipment-provided',
    activityTypes: [
      'GROUP_LESSON' as ActivityTypeEnum,
      'GROUP_OUTING' as ActivityTypeEnum,
      'WORKSHOP' as ActivityTypeEnum,
      'MULTI_DAY_COURSE' as ActivityTypeEnum,
      'EVENT' as ActivityTypeEnum,
      'PLAYGROUND_RENT' as ActivityTypeEnum,
      'BIRTHDAY' as ActivityTypeEnum,
      'PRODUCT_TEST' as ActivityTypeEnum,
    ],
  },
  {
    routeName: 'organizer.activity-creation.equipment-required',
  },
  {
    routeName: 'organizer.activity-creation.plans',
  },
  {
    routeName: 'organizer.activity-creation.birthday-sport-offer',
    activityTypes: [
      'BIRTHDAY' as ActivityTypeEnum,
      'PRODUCT_TEST' as ActivityTypeEnum,
    ],
  },
  {
    routeName: 'organizer.activity-creation.description',
  },
  {
    routeName: 'organizer.activity-creation.title',
  },
  {
    routeName: 'organizer.activity-creation.photos',
  },
  {
    routeName: 'organizer.activity-creation.uploads',
  },
  {
    routeName: 'organizer.activity-creation.group-size',
    excludeActivityTypes: [
      'BIRTHDAY' as ActivityTypeEnum,
      'PRODUCT_TEST' as ActivityTypeEnum,
    ],
  },
  {
    routeName: 'organizer.activity-creation.url',
    activityTypes: ['LIVE' as ActivityTypeEnum],
  },
  {
    routeName: 'organizer.activity-creation.preview',
  },
];
